import type { LocalChartRepository } from './localPersistence.js';
import type { ResultActionId } from './resultActionsPresentation.js';

export type ProductionDeleteActionId = Extract<ResultActionId, 'delete_saved_chart' | 'clear_all_local_charts'>;

export interface ProductionDeleteResult {
  action: ProductionDeleteActionId;
  beforeCount: number;
  afterCount: number;
  deletedCount: number;
  disclosure: string;
}

export function executeProductionDeleteAction(
  action: ProductionDeleteActionId,
  repository: LocalChartRepository,
  options: Readonly<{ confirmed: boolean; chartId?: string }>,
): ProductionDeleteResult {
  if (!options.confirmed) throw new Error('Production delete action requires explicit confirmation');
  const beforeCount = repository.list().length;
  if (action === 'delete_saved_chart') {
    const chartId = options.chartId?.trim();
    if (!chartId) throw new Error('Deleting one saved chart requires a chart ID');
    repository.delete(chartId);
  } else if (action === 'clear_all_local_charts') {
    repository.clear();
  } else {
    throw new Error(`Unsupported production delete action ${String(action)}`);
  }
  const afterCount = repository.list().length;
  return Object.freeze({
    action,
    beforeCount,
    afterCount,
    deletedCount: Math.max(0, beforeCount - afterCount),
    disclosure: action === 'clear_all_local_charts'
      ? '已清除本專案本機 namespace 中的命盤；其他網站或其他 LocalStorage key 不在此操作範圍。'
      : '已刪除指定的本機命盤；其他命盤與其他網站資料不受影響。',
  });
}
